document.querySelectorAll('.aom-faq-question').forEach((button) => {
  if (button.dataset.aomBound === 'true') return;
  button.dataset.aomBound = 'true';
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const isVisible = answer.style.display === 'block';
    if (isVisible) {
      answer.style.display = 'none';
      button.classList.remove('active');
      aomTrack('aom_faq_toggle', {
        ui_element: 'faq_accordion',
        action_type: 'collapse',
        question_text: button.textContent.trim().substring(0, 100),
      });
    } else {
      answer.style.display = 'block';
      button.classList.add('active');
      aomTrack('aom_faq_toggle', {
        ui_element: 'faq_accordion',
        action_type: 'expand',
        question_text: button.textContent.trim().substring(0, 100),
      });
    }
  });
});
